/**
 * KAIA — KIKABONI WELLNESS ADVISOR
 * Chat Widget v5.0 — Taia-inspired professional design
 */

(function () {
  'use strict';
  console.log('%c Kaia Widget v15.0 loaded ', 'background:#36AAA9;color:#fff;padding:2px 8px;border-radius:4px;');

  const CONFIG = {
    workerUrl: 'https://kaia-wellness-advisor.kikaboni.workers.dev',
    advisorName: 'Kaia',
    brandTeal: '#36AAA9',
    brandNavy: '#1E6581',
    brandCream: '#FAF8F3',
    brandNearBlack: '#1A1A2E',
    brandGray: '#666666',
    fontFamily: "'DM Sans', Arial, sans-serif",
    sessionKey: 'kaia_conversation',
    maxStoredMessages: 12,
    logoMark: 'data:image/png;base64,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',
    greeting: "Hello, I'm Kaia, your Wellness Advisor",
    intro: "I'm here to help you find the right support for whatever your wellness goals are.",
    subIntro: "Ask me any wellness question, or select a topic below to start a conversation.",
    suggestedPrompts: [
      "What products are right for me?",
      "How can I reduce my stress?",
      "Help me improve my sleep",
      "What supports gut health?",
      "Tips for healthy weight management"
    ],
    homepageHeroId: 'kikaboni-advisor-hero',
    buildStackUrl: 'https://kikaboni.com/pages/build-your-stack',
    buildStackLabel: 'Build Your Stack',
    quizStateKey: 'kbQuiz.v1',
    consentKey: 'kaia_consent_given',
    consentText: "Before we continue, Kaia is a generative AI-powered wellness advisor and is not a human or medical expert. By clicking \"I agree\" below, you acknowledge that your use of Kaia is subject to our Terms of Service, and you agree that Kikaboni may collect and use the information you provide through your responses to recommend specific Kikaboni products or wellness guidance for your needs, and for related business purposes such as improving the Kaia experience.",
    consentSubText: "Kaia is intended for US customers only. Any personal data you provide when using Kaia will be processed in accordance with our Privacy Policy.",
    termsUrl: "https://kikaboni.com/pages/terms-of-service",
    privacyUrl: "https://kikaboni.com/pages/privacy-policy",
  };

  function getCustomerIdentity() {
    try {
      return {
        email: window.__kaiaCustomerEmail || null,
        firstName: window.__kaiaCustomerFirstName || null
      };
    } catch {
      return { email: null, firstName: null };
    }
  }

  // The Build Your Stack quiz saves its answers in sessionStorage on the same origin.
  // Only a finished quiz is shared, so Kaia never builds on half-answered goals.
  // Contact details are left out; Kaia only needs the answers.
  function getQuizResult() {
    try {
      const quiz = JSON.parse(sessionStorage.getItem(CONFIG.quizStateKey) || 'null');
      if (!quiz || !quiz.submitted || !quiz.a || !quiz.a.primary) return null;
      const { primary, secondary, focus, experience, diets, safety } = quiz.a;
      return {
        primary,
        secondary: secondary || null,
        focus: focus || null,
        experience: experience || null,
        diets: diets || [],
        safety: safety || [],
        // The quiz only saves a tier the visitor picked; otherwise it shows
        // its default (Full for active supplement users, Starter otherwise)
        tier: quiz.tier || (experience === 'active' ? 'full' : 'starter')
      };
    } catch { return null; }
  }

  // Tells Kaia which page the visitor is on, so she can resolve "this" or
  // "it" in a question. She is told never to raise the page herself.
  function getPageContext() {
    try {
      const path = location.pathname.replace(/\/$/, '') || '/';
      const m = path.match(/^\/(products|collections|blogs|pages)\/([^/]+)(?:\/([^/]+))?/);
      let type = path === '/' ? 'home' : 'other';
      if (m) type = m[1] === 'blogs' ? (m[3] ? 'article' : 'blog') : m[1].replace(/s$/, '');
      const title = document.querySelector('meta[property="og:title"]')?.content || document.title || '';
      return { type, handle: m ? (m[3] || m[2]) : null, title: title.slice(0, 120) };
    } catch { return null; }
  }

  function getHistory() {
    try {
      const stored = sessionStorage.getItem(CONFIG.sessionKey);
      return stored ? JSON.parse(stored) : [];
    } catch { return []; }
  }

  function hasConsent() {
    try {
      return localStorage.getItem(CONFIG.consentKey) === 'true';
    } catch { return false; }
  }

  function setConsent() {
    try {
      localStorage.setItem(CONFIG.consentKey, 'true');
    } catch {}
  }

  function saveHistory(history) {
    try {
      sessionStorage.setItem(CONFIG.sessionKey, JSON.stringify(history.slice(-CONFIG.maxStoredMessages)));
    } catch {}
  }

  function injectStyles() {
    if (document.getElementById('kaia-styles')) return;
    const s = document.createElement('style');
    s.id = 'kaia-styles';
    s.textContent = `
      #kaia-bubble, #kaia-panel {
        box-sizing: border-box;
        font-family: ${CONFIG.fontFamily};
      }
      #kaia-bubble *, #kaia-panel * { box-sizing: border-box; }

      /* Floating bubble — pill with icon + label */
      #kaia-bubble {
        position: fixed;
        bottom: 24px;
        right: 24px;
        height: 52px;
        padding: 0 24px;
        background: ${CONFIG.brandTeal};
        border-radius: 100px;
        cursor: pointer;
        z-index: 9998;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 20px rgba(30,101,129,0.35);
        transition: transform 0.2s, box-shadow 0.2s, background 0.2s;
        border: none;
        outline: none;
        white-space: nowrap;
      }
      #kaia-bubble:hover {
        background: ${CONFIG.brandNavy};
        transform: translateY(-2px);
        box-shadow: 0 6px 24px rgba(30,101,129,0.45);
      }
      #kaia-bubble .kaia-bubble-text {
        font-size: 15px;
        font-weight: 700;
        color: #ffffff;
        letter-spacing: 0.2px;
        font-family: ${CONFIG.fontFamily};
      }


      /* Panel */
      #kaia-panel {
        position: fixed;
        bottom: 0;
        right: 24px;
        width: 400px;
        max-width: calc(100vw - 48px);
        height: 620px;
        max-height: calc(100vh - 40px);
        background: #ffffff;
        border-radius: 12px 12px 0 0;
        box-shadow: 0 -4px 40px rgba(26,26,46,0.18);
        z-index: 9999;
        display: none;
        flex-direction: column;
        overflow: hidden;
      }
      #kaia-panel.kaia-open { display: flex; animation: kaiaSlide 0.25s ease; }
      @keyframes kaiaSlide {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
      }

      /* Header */
      .kaia-header {
        background: ${CONFIG.brandNavy};
        padding: 18px 20px;
        display: flex;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
      }
      #kaia-panel .kaia-header-mark { width: 32px !important; height: 32px !important; object-fit: contain !important; flex-shrink: 0 !important; image-rendering: -webkit-optimize-contrast !important; }
      #kaia-panel .kaia-header-info { flex: 1 !important; }
      #kaia-panel .kaia-header-name {
        font-size: 16px !important;
        font-weight: 700 !important;
        color: #ffffff !important;
        letter-spacing: 0.3px !important;
        line-height: 1.2 !important;
      }
      #kaia-panel .kaia-header-sub {
        font-size: 11px !important;
        color: rgba(255,255,255,0.7) !important;
        margin-top: 2px !important;
        line-height: 1.2 !important;
      }
      .kaia-header-close, .kaia-header-reset {
        background: none;
        border: none;
        cursor: pointer;
        color: rgba(255,255,255,0.75);
        padding: 4px;
        display: flex;
        align-items: center;
        transition: color 0.15s;
      }
      .kaia-header-close:hover, .kaia-header-reset:hover { color: #ffffff; }
      .kaia-header-close svg { width: 20px; height: 20px; }
      .kaia-header-reset svg { width: 18px; height: 18px; }

      /* Messages */
      #kaia-panel .kaia-messages {
        flex: 1 !important;
        overflow-y: auto !important;
        padding: 20px !important;
        display: flex !important;
        flex-direction: column !important;
        gap: 16px !important;
        background: #ffffff !important;
        scroll-behavior: smooth !important;
      }
      .kaia-messages::-webkit-scrollbar { width: 5px; }
      .kaia-messages::-webkit-scrollbar-thumb { background: rgba(30,101,129,0.2); border-radius: 3px; }

      /* Intro block */
      #kaia-panel .kaia-intro-greeting {
        font-size: 18px !important;
        font-weight: 700 !important;
        color: ${CONFIG.brandNearBlack} !important;
        line-height: 1.3 !important;
        margin: 0 0 14px 0 !important;
      }
      #kaia-panel .kaia-intro-text {
        font-size: 13.5px !important;
        color: ${CONFIG.brandNearBlack} !important;
        line-height: 1.6 !important;
        margin: 0 0 14px 0 !important;
      }
      #kaia-panel .kaia-intro-sub {
        font-size: 13.5px !important;
        color: ${CONFIG.brandGray} !important;
        line-height: 1.6 !important;
        margin: 0 0 20px 0 !important;
      }

      /* Suggested prompt chips */
      #kaia-panel .kaia-prompts {
        display: flex !important;
        flex-direction: column !important;
        gap: 10px !important;
        align-items: flex-start !important;
        margin-top: 8px !important;
      }
      #kaia-panel .kaia-prompt-chip {
        background: ${CONFIG.brandTeal} !important;
        color: #ffffff !important;
        border: none !important;
        border-radius: 100px !important;
        padding: 10px 18px !important;
        font-size: 13.5px !important;
        font-weight: 500 !important;
        font-family: ${CONFIG.fontFamily} !important;
        cursor: pointer !important;
        transition: background 0.15s, transform 0.15s !important;
        text-align: left !important;
        line-height: 1.3 !important;
        width: auto !important;
        display: inline-block !important;
        text-decoration: none !important;
        margin: 0 !important;
        box-shadow: none !important;
      }
      #kaia-panel .kaia-prompt-chip:hover {
        background: ${CONFIG.brandNavy} !important;
        transform: translateX(2px) !important;
      }

      /* Message bubbles */
      .kaia-msg { display: flex; flex-direction: column; max-width: 90%; }
      .kaia-msg-kaia { align-self: flex-start; }
      .kaia-msg-user { align-self: flex-end; }
      .kaia-msg-bubble { font-size: 12.5px; line-height: 1.65; }
      .kaia-msg-kaia .kaia-msg-bubble {
        color: ${CONFIG.brandNearBlack};
      }
      .kaia-msg-user .kaia-msg-bubble {
        background: ${CONFIG.brandNavy};
        color: #ffffff;
        padding: 11px 16px;
        border-radius: 16px 16px 4px 16px;
      }
      .kaia-msg-bubble p { margin: 0 0 10px 0; }
      .kaia-msg-bubble p:last-child { margin-bottom: 0; }
      .kaia-msg-bubble ul, .kaia-msg-bubble ol { margin: 8px 0 10px 20px; padding: 0; }
      .kaia-msg-bubble li { margin-bottom: 6px; line-height: 1.55; }
      .kaia-msg-bubble strong { font-weight: 600; }
      .kaia-msg-bubble a { color: ${CONFIG.brandTeal}; text-decoration: underline; }

      /* Typing */
      .kaia-typing { display: flex; gap: 4px; padding: 4px 0; }
      .kaia-typing span {
        width: 7px; height: 7px; background: ${CONFIG.brandTeal};
        border-radius: 50%; animation: kaiaDot 1.2s ease-in-out infinite;
      }
      .kaia-typing span:nth-child(2) { animation-delay: 0.2s; }
      .kaia-typing span:nth-child(3) { animation-delay: 0.4s; }
      @keyframes kaiaDot {
        0%,60%,100% { transform: translateY(0); opacity: 0.4; }
        30% { transform: translateY(-4px); opacity: 1; }
      }

      /* Input */
      #kaia-panel .kaia-input-area {
        padding: 12px 16px 14px !important;
        background: #ffffff !important;
        border-top: 1px solid rgba(30,101,129,0.1) !important;
        display: flex !important;
        gap: 8px !important;
        align-items: center !important;
        flex-shrink: 0 !important;
      }
      #kaia-panel .kaia-input {
        flex: 1 !important;
        border: 1.5px solid rgba(30,101,129,0.2) !important;
        border-radius: 24px !important;
        padding: 10px 16px !important;
        font-size: 13.5px !important;
        font-family: ${CONFIG.fontFamily} !important;
        color: ${CONFIG.brandNearBlack} !important;
        background: #ffffff !important;
        resize: none !important;
        outline: none !important;
        line-height: 1.4 !important;
        min-height: 42px !important;
        max-height: 90px !important;
        transition: border-color 0.2s !important;
      }
      .kaia-input:focus { border-color: ${CONFIG.brandTeal}; }
      .kaia-input::placeholder { color: ${CONFIG.brandGray}; }
      #kaia-panel .kaia-send {
        width: 40px !important; height: 40px !important;
        background: ${CONFIG.brandTeal} !important;
        border: none !important; border-radius: 50% !important;
        cursor: pointer !important;
        display: flex !important; align-items: center !important; justify-content: center !important;
        flex-shrink: 0 !important;
        transition: background 0.2s, transform 0.15s !important;
      }
      .kaia-send:hover { background: ${CONFIG.brandNavy}; transform: scale(1.05); }
      .kaia-send:disabled { background: #D3D1C7; cursor: not-allowed; transform: none; }
      .kaia-send svg { width: 18px; height: 18px; fill: #ffffff; }

      .kaia-footer {
        padding: 0 20px 14px;
        background: #ffffff;
        text-align: center;
        font-size: 10px;
        color: ${CONFIG.brandGray};
        flex-shrink: 0;
      }

      /* Consent gate */
      #kaia-panel .kaia-consent {
        flex: 1 !important;
        overflow-y: auto !important;
        padding: 24px 20px !important;
        display: flex !important;
        flex-direction: column !important;
        background: #ffffff !important;
      }
      #kaia-panel .kaia-consent-text {
        font-size: 13px !important;
        color: ${CONFIG.brandNearBlack} !important;
        line-height: 1.65 !important;
        margin: 0 0 16px 0 !important;
      }
      #kaia-panel .kaia-consent-sub {
        font-size: 12.5px !important;
        color: ${CONFIG.brandGray} !important;
        line-height: 1.6 !important;
        margin: 0 !important;
      }
      #kaia-panel .kaia-consent a {
        color: ${CONFIG.brandTeal} !important;
        text-decoration: underline !important;
      }
      #kaia-panel .kaia-consent-btn {
        margin: 20px 20px 24px !important;
        padding: 14px !important;
        background: ${CONFIG.brandNavy} !important;
        color: #ffffff !important;
        border: none !important;
        border-radius: 100px !important;
        font-size: 15px !important;
        font-weight: 600 !important;
        font-family: ${CONFIG.fontFamily} !important;
        cursor: pointer !important;
        transition: background 0.2s !important;
        flex-shrink: 0 !important;
      }
      #kaia-panel .kaia-consent-btn:hover {
        background: ${CONFIG.brandTeal} !important;
      }

      @media (max-width: 480px) {
        #kaia-panel {
          right: 0; bottom: 0; width: 100%; max-width: 100%;
          height: 100%; max-height: 100%; border-radius: 0;
        }
        #kaia-bubble { bottom: 16px; right: 16px; }
      }
      @media (prefers-reduced-motion: reduce) {
        #kaia-panel.kaia-open { animation: none; }
        .kaia-typing span { animation: none; opacity: 0.6; }
      }
    `;
    document.head.appendChild(s);
  }

  const ICONS = {
    close: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>`,
    send: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></svg>`,
    reset: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" fill="currentColor"/></svg>`,
  };

  function createChatEngine(panel) {
    const identity = getCustomerIdentity();
    let history = getHistory();
    let isStreaming = false;
    let introShown = false;

    const messagesEl = panel.querySelector('.kaia-messages');
    const inputEl = panel.querySelector('.kaia-input');
    const sendBtn = panel.querySelector('.kaia-send');

    // Show intro screen with prompts, or restore history
    if (history.length === 0) {
      showIntro();
    } else {
      history.forEach((m) => addMessage(m.role === 'assistant' ? 'kaia' : 'user', m.content, false));
    }
    scrollToBottom();

    function removeConsentButton() {
      panel.querySelectorAll('.kaia-consent-btn').forEach(function(b) { b.remove(); });
    }

    function showConsentGate() {
      removeConsentButton();
      messagesEl.innerHTML = '';

      const consent = document.createElement('div');
      consent.className = 'kaia-consent';
      consent.innerHTML = `
        <div class="kaia-consent-text">${CONFIG.consentText.replace('Terms of Service', '<a href="' + CONFIG.termsUrl + '" target="_blank">Terms of Service</a>')}</div>
        <div class="kaia-consent-sub">${CONFIG.consentSubText.replace('Privacy Policy', '<a href="' + CONFIG.privacyUrl + '" target="_blank">Privacy Policy</a>')}</div>
      `;
      messagesEl.appendChild(consent);

      const btn = document.createElement('button');
      btn.className = 'kaia-consent-btn';
      btn.textContent = 'I agree';
      btn.addEventListener('click', () => {
        setConsent();
        removeConsentButton();
        messagesEl.innerHTML = '';
        if (pendingMessage) {
          const msg = pendingMessage;
          pendingMessage = null;
          inputEl.value = msg;
          send();
        } else {
          showIntro();
        }
      });

      const inputArea = panel.querySelector('.kaia-input-area');
      inputArea.parentNode.insertBefore(btn, inputArea);
    }

    function showIntro() {
      introShown = true;
      // No point linking to the quiz from the quiz page itself
      const onQuizPage = location.pathname.replace(/\/$/, '') === new URL(CONFIG.buildStackUrl).pathname;
      const stackLink = onQuizPage ? '' : `<a class="kaia-stack-cta" href="${CONFIG.buildStackUrl}" style="background:${CONFIG.brandNavy};color:#ffffff;border:none;border-radius:100px;padding:9px 16px;font-size:13px;font-weight:600;font-family:${CONFIG.fontFamily};cursor:pointer;line-height:1.3;width:auto;display:inline-block;text-decoration:none;margin:0;box-shadow:none;">${CONFIG.buildStackLabel} &rarr;</a>`;
      const intro = document.createElement('div');
      intro.className = 'kaia-intro';
      intro.innerHTML = `
        <div class="kaia-intro-greeting">${CONFIG.greeting}</div>
        <div class="kaia-intro-text">${CONFIG.intro}</div>
        <div class="kaia-intro-sub">${CONFIG.subIntro}</div>
        <div class="kaia-prompts">
          ${stackLink}
          ${CONFIG.suggestedPrompts.map(p => `<button class="kaia-prompt-chip" style="background:${CONFIG.brandTeal};color:#ffffff;border:none;border-radius:100px;padding:9px 16px;font-size:13px;font-weight:500;font-family:${CONFIG.fontFamily};cursor:pointer;text-align:left;line-height:1.3;width:auto;display:inline-block;text-decoration:none;margin:0;box-shadow:none;white-space:normal;">${p}</button>`).join('')}
        </div>
      `;
      messagesEl.appendChild(intro);

      const stackCta = intro.querySelector('.kaia-stack-cta');
      if (stackCta) {
        stackCta.addEventListener('mouseenter', () => { stackCta.style.background = CONFIG.brandTeal; });
        stackCta.addEventListener('mouseleave', () => { stackCta.style.background = CONFIG.brandNavy; });
      }

      intro.querySelectorAll('.kaia-prompt-chip').forEach((chip) => {
        chip.addEventListener('mouseenter', () => { chip.style.background = CONFIG.brandNavy; });
        chip.addEventListener('mouseleave', () => { chip.style.background = CONFIG.brandTeal; });
        chip.addEventListener('click', () => {
          inputEl.value = chip.textContent;
          send();
        });
      });
    }

    function clearIntro() {
      const intro = messagesEl.querySelector('.kaia-intro');
      if (intro) intro.remove();
    }

    let pendingMessage = null;

    async function send() {
      const text = inputEl.value.trim();
      if (!text || isStreaming) return;

      // Consent gate — intercept first message if consent not given
      if (!hasConsent()) {
        pendingMessage = text;
        showConsentGate();
        return;
      }

      if (introShown) { clearIntro(); introShown = false; }

      inputEl.value = '';
      inputEl.style.height = 'auto';
      isStreaming = true;
      sendBtn.disabled = true;

      addMessage('user', text, true);
      history.push({ role: 'user', content: text });
      saveHistory(history);

      const typingEl = addTyping();

      try {
        const response = await fetch(CONFIG.workerUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: text,
            conversationHistory: history.slice(0, -1),
            customerEmail: identity.email,
            customerFirstName: identity.firstName,
            // Read on every send so a quiz finished mid-chat is picked up
            quizResult: getQuizResult(),
            pageContext: getPageContext(),
          }),
        });

        if (!response.ok) throw new Error(`Worker error: ${response.status}`);

        typingEl.remove();
        const bubble = addMessage('kaia', '', true);
        const bubbleText = bubble.querySelector('.kaia-msg-bubble');

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let fullText = '';
        let fullVisible = '';

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value, { stream: true });
          const visible = chunk.replace(/<!--KAIA_FLAGS:.*?-->/gs, '');
          fullText += chunk;
          fullVisible += visible;
          bubbleText.innerHTML = fullVisible;
          scrollToBottom();
        }

        const cleanText = fullText.replace(/<!--KAIA_FLAGS:.*?-->/gs, '').trim();
        history.push({ role: 'assistant', content: cleanText });
        saveHistory(history);

      } catch (err) {
        typingEl?.remove();
        addMessage('kaia', '<p>Something went wrong on my end — please try again in a moment.</p>', true);
        console.error('Kaia error:', err);
      } finally {
        isStreaming = false;
        sendBtn.disabled = false;
        inputEl.focus();
      }
    }

    function addMessage(role, html, animate) {
      const msg = document.createElement('div');
      msg.className = `kaia-msg kaia-msg-${role}`;
      const bubble = document.createElement('div');
      bubble.className = 'kaia-msg-bubble';
      if (role === 'kaia') bubble.innerHTML = html;
      else bubble.textContent = html;
      msg.appendChild(bubble);
      messagesEl.appendChild(msg);
      scrollToBottom();
      return msg;
    }

    function addTyping() {
      const el = document.createElement('div');
      el.className = 'kaia-msg kaia-msg-kaia';
      el.innerHTML = `<div class="kaia-typing"><span></span><span></span><span></span></div>`;
      messagesEl.appendChild(el);
      scrollToBottom();
      return el;
    }

    function scrollToBottom() { messagesEl.scrollTop = messagesEl.scrollHeight; }

    sendBtn.addEventListener('click', send);
    inputEl.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
    });
    inputEl.addEventListener('input', () => {
      inputEl.style.height = 'auto';
      inputEl.style.height = Math.min(inputEl.scrollHeight, 100) + 'px';
    });

    // Reset conversation — clear history and show intro again
    function resetChat() {
      if (isStreaming) return;
      history = [];
      try { sessionStorage.removeItem(CONFIG.sessionKey); } catch {}
      messagesEl.innerHTML = '';
      showIntro();
      inputEl.value = '';
      inputEl.focus();
    }

    // Expose reset to the panel's reset button
    const resetBtn = panel.querySelector('.kaia-header-reset');
    if (resetBtn) resetBtn.addEventListener('click', resetChat);

    // Lets other page code (e.g. the quiz results) start a question for the visitor
    return {
      ask(text) {
        if (isStreaming || !text) return;
        inputEl.value = text;
        send();
      },
    };
  }

  function buildPanelHTML() {
    return `
      <div class="kaia-header">
        <img class="kaia-header-mark" src="${CONFIG.logoMark}" alt="" />
        <div class="kaia-header-info">
          <div class="kaia-header-name">${CONFIG.advisorName}</div>
          <div class="kaia-header-sub">Kikaboni Wellness Advisor</div>
        </div>
        <button class="kaia-header-reset" aria-label="Start new conversation" title="Start new conversation">${ICONS.reset}</button>
        <button class="kaia-header-close" aria-label="Close chat">${ICONS.close}</button>
      </div>
      <div class="kaia-messages" role="log" aria-live="polite"></div>
      <div class="kaia-input-area">
        <textarea class="kaia-input" placeholder="Chat with Kaia" rows="1" maxlength="1000"></textarea>
        <button class="kaia-send" aria-label="Send">${ICONS.send}</button>
      </div>
      <div class="kaia-footer">Kaia provides wellness guidance, not medical advice. Always consult a healthcare provider for medical decisions.</div>
    `;
  }

  function init() {
    injectStyles();

    const bubble = document.createElement('button');
    bubble.id = 'kaia-bubble';
    bubble.setAttribute('aria-label', 'Chat with Kaia');
    bubble.innerHTML = `<span class="kaia-bubble-text">Ask Kaia</span>`;

    const panel = document.createElement('div');
    panel.id = 'kaia-panel';
    panel.setAttribute('role', 'dialog');
    panel.innerHTML = buildPanelHTML();

    document.body.appendChild(bubble);
    document.body.appendChild(panel);

    panel.querySelector('.kaia-header-close').addEventListener('click', () => {
      panel.classList.remove('kaia-open');
    });

    bubble.addEventListener('click', () => {
      const open = panel.classList.toggle('kaia-open');
      if (open) panel.querySelector('.kaia-input').focus();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel.classList.contains('kaia-open')) {
        panel.classList.remove('kaia-open');
      }
    });

    const engine = createChatEngine(panel);

    // Public API: window.Kaia.open() opens the chat; open({ message }) also
    // sends that message as the visitor, e.g. from the quiz results button
    window.Kaia = {
      open(options = {}) {
        panel.classList.add('kaia-open');
        if (options.message) engine.ask(options.message);
        else panel.querySelector('.kaia-input').focus();
      },
    };
    // The quiz may render before this script runs, so announce readiness
    document.dispatchEvent(new CustomEvent('kaia:ready'));
  }

  // A second copy of the script (e.g. a leftover ScriptTag) must not add a
  // second bubble. The flag is set before init runs, so it also catches a
  // copy that loads while the page is still loading.
  if (window.__kaiaWidgetLoaded) return;
  window.__kaiaWidgetLoaded = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
